import { render } from "./TombstonePopover.vue?vue&type=template&id=2193288c&scoped=true"
import script from "./TombstonePopover.vue?vue&type=script&lang=js"
export * from "./TombstonePopover.vue?vue&type=script&lang=js"

import "./TombstonePopover.vue?vue&type=style&index=0&id=2193288c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2193288c"

export default script